import {Component, Input} from "@angular/core";
import {VALUE_TYPE} from "../../enums/enums";
import {WatchService} from "../../services/watch.service";


@Component({
  selector: "nv-list-ids",
  templateUrl: "./nv-list-ids.component.html"
})


export class NvListIdsComponent {
  @Input() val_type: VALUE_TYPE;
  @Input() document: any;
  @Input() prop: string;

  @Input() showAddButton = true;
  @Input() showRemoveButton = true;


  _label: string;
  @Input() set label(v: string) {
    this._label = v;
  }

  get label(): string {
    return this._label || this.prop;
  }


  constructor(private watchService: WatchService) {
  }


  trackByIndex(index: number, value: any) {
    return index;
  }


  onInputChange() {
      this.watchService.notify();
  }


  addItem() {
    if (typeof this.document[this.prop] === "undefined") {
      this.document[this.prop] = []; // todo watch service!
    }
    this.document[this.prop].push(0);
    this.watchService.notify();
  }


  removeItem(index: number) {
    let c = this.document[this.prop];
    c.splice(index, 1);
    this.watchService.notify();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-list-ids/nv-list-ids.component.ts